import { useMemo } from "react";

const FEATURE_FLAGS = (() => {
  try {
    return JSON.parse(process.env.GATSBY_GAC_FEATURE_FLAGS || "{}") || {};
  } catch {
    return {};
  }
})();

export function useFeatureFlag(key: string) {
  return useMemo(() => (key in FEATURE_FLAGS ? String(FEATURE_FLAGS[key]) : null), [key]);
}
